import gql from 'graphql-tag';

export const DASHBOARD_QUERY = gql`
  query Dashboard(
    $todayStart: String!
    $sevenDaysFromTodayStart: String!
  ) {
    plantings(
      filters: [
        { name: "planting.planting_time", operator: "<=", value: $sevenDaysFromTodayStart }
        { name: "order.order_fulfillment_time", operator: ">=", value: $todayStart }
      ]
    ) {
      edges {
        node {
          id
          planting_time
          planting_status
          planting_state
          trays_rounded
          crop {
            id
            crop_name
          }
          order_id
          tasks {
            edges {
              node {
                id
                task_name
                task_status
                task_time
                task_completed_time
              }
            }
          }
        }
      }
    }
    tasks(
      filters: [
        { name: "task.task_time", operator: ">=", value: $todayStart }
        { name: "task.task_time", operator: "<=", value: $sevenDaysFromTodayStart }
      ]
    ) {
      edges {
        node {
          id
          task_name
          task_status
          task_time
          task_completed_by_name
          task_completed_time
          planting {
            id
            order_id
            trays_rounded
            planting_time
            planted_at
          }
          crop {
            id
            crop_name
            sowing_density
            sow_density_unit
            steps {
              edges {
                node {
                  id
                  name
                  time_to_start_after_first_step
                }
              }
            }
          }
        }
      }
    }
    orders(
      filters: [
        { name: "order.order_fulfillment_time", operator: "<=", value: $sevenDaysFromTodayStart }
        { name: "order.order_fulfillment_time", operator: ">=", value: $todayStart }
        { name: "order.order_status", operator: "!=", value: "cancelled" }
      ]
      orderBy: [
        { name: "order.order_fulfillment_time", direction: "asc" }
        { name: "order.customer", direction: "asc" }
      ]
    ) {
      edges {
        node {
          id
          order_status
          customer
          order_fulfillment_time
        }
      }
    }
  }
`;

export const DASHBOARD_OVERDUE_TASKS_QUERY = gql`
  query DashboardOverdueTasks($todayStart: String!, $first: Int!, $after: String) {
    task_groups(
      filters: [
        { name: "task.task_time", operator: "<", value: $todayStart }
        { name: "task.task_status", operator: "!=", value: "completed" }
        { name: "task.task_status", operator: "!=", value: "cancelled" }
      ]
      first: $first
      after: $after
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
      }
      edges {
        node {
          tasks {
            id
            task_name
            task_status
            task_time
            task_completed_time
            planting {
              id
              order_id
              trays_rounded
              planting_time
              planted_at
            }
          }
          crop {
            id
            crop_name
          }
        }
      }
    }
  }
`;

export const DASHBOARD_TASKS_COMPLETED_TODAY_QUERY = gql`
  query DashboardTasksCompletedToday(
    $todayStart: String!
    $todayEnd: String!
    $first: Int!
    $after: String
  ) {
    task_groups(
      filters: [
        { name: "task.task_completed_time", operator: ">=", value: $todayStart }
        { name: "task.task_completed_time", operator: "<=", value: $todayEnd }
        { name: "task.task_status", operator: "=", value: "completed" }
      ]
      first: $first
      after: $after
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
      }
      edges {
        node {
          tasks {
            id
            task_name
            task_status
            task_time
            task_completed_by_name
            task_completed_time
            planting {
              id
              order_id
              trays_rounded
            }
          }
          crop {
            id
            crop_name
          }
        }
      }
    }
  }
`;
